import Glide from "@glidejs/glide";

export default class ArticleSlider {
    
    static get selector() {
        return '.articleSlider';
    }

    constructor(el) {
        this.el = el;
        this.eSlider = this.el.querySelector('.articleSlider__slider');
        this.slider = new Glide(this.eSlider, {
            type: 'carousel',
            startAt: 0,
            perView: 4,
            classes: {
                direction: {
                    ltr: 'glide--ltr',
                    rtl: 'glide--rtl'
                },
                slider: 'glide--slider',
                carousel: 'glide--carousel',
                swipeable: 'glide--swipeable',
                dragging: 'glide--dragging',
                cloneSlide: 'glide__slide--clone',
                activeNav: 'glide__bullet--active',
                activeSlide: 'glide__slide--active',
                disabledArrow: 'glide__arrow--disabled'
            },
            breakpoints: {
                1100: {
                    perView: 3,
                    peek: {
                        before: 120,
                        after: 120
                    }
                },
                850: {
                    perView: 2,
                    peek: {
                        before: 120,
                        after: 120
                    }
                },
                700: {
                    perView: 1,
                    peek: (window.innerWidth - 173) /2
                }
                
            }

        });


        this.slider.mount();
    }

}